import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { h, toRefs } from "vue";
import { LoadingOutlined } from "@ant-design/icons-vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Spin',
  props: {
  loading: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props


const { loading } = toRefs(props);
const indicator = h(LoadingOutlined, {
  style: {
    fontSize: "1rem",
  },
  spin: true,
});

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_unref(loading))
    ? (_openBlock(), _createBlock(_component_a_spin, {
        key: 0,
        indicator: _unref(indicator)
      }, null, 8, ["indicator"]))
    : _createCommentVNode("", true)
}
}

})